export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/de.lyaml"));
at({ "de": { "public": { "sampleString": "Beispieltzeichenfolge" } } });
};